module.exports = __webpack_public_path__ + "img/success.7d1fdd87.svg";